import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Admissionleft from './Admissoinleft';
import { Container, Row, Col, Button, Table } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';


function Test_Phd_AdmissionELe() {

	const [datesOpen, setDatesOpen] = useState(true);
	const [guidelinesOpen, setGuidelinesOpen] = useState(false);
	const [categoryOpen, setCategoryOpen] = useState(false);
	const [areasOpen, setAreasOpen] = useState(false);
	const [eligiblityOpen, setEligiblityOpen] = useState(false);
	const [financialOpen, setFinancialOpen] = useState(false);
	const [sectionOpen, setSectionOpen] = useState(false);
	const [documentsOpen, setDocumentsOpen] = useState(false);
	const [feesOpen, setFeesOpen] = useState(false);
	const [applyonlineOpen, setApplyonlineOpen] = useState(false);

	const handleClick = (event) => {
		setDatesOpen(false);
		setGuidelinesOpen(false);
		setCategoryOpen(false);
		setAreasOpen(false);
		setEligiblityOpen(false);
		setFinancialOpen(false);
		setSectionOpen(false);
		setDocumentsOpen(false);
		setFeesOpen(false);
		setApplyonlineOpen(false);
		event(true);
	}

	return (
		<section className="project-detail">
			<Container>
				{/* <> */}
				<Row>
					<Col md={4} className='c-left custom-padding-color mb-4'>
						<Admissionleft activeIndex={0} />
					</Col>

					<Col md={8} className='c-right'>

						<div className="c-heading">
							<h3>Ph.D.</h3> <br />
						</div>

						<Row className='mb-5'>
							{/* /backup xs={6} sm={4} md={3} lg={3}/ */}
							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button'
									onClick={() => handleClick(setDatesOpen)}
									aria-controls="example-fade-text"
									aria-expanded={datesOpen}>
									Dates
								</Button>
							</Col>

							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button '
									onClick={() => handleClick(setGuidelinesOpen)}
									aria-controls="c-guidelines"
									aria-expanded={guidelinesOpen}>
									Guidelines
								</Button>
							</Col>

							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button '
									onClick={() => handleClick(setCategoryOpen)}
									aria-controls="c-categoryOpen"
									aria-expanded={categoryOpen}>
									Categories
								</Button>
							</Col>

							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button '
									onClick={() => handleClick(setAreasOpen)}
									aria-controls="c-areas"
									aria-expanded={areasOpen}>
									Areas
								</Button>
							</Col>

							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button '
									onClick={() => handleClick(setEligiblityOpen)}
									aria-controls="c-eligiblity"
									aria-expanded={eligiblityOpen}>
									Eligiblity
								</Button>
							</Col>

							{/* financial */}
							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button '
									onClick={() => handleClick(setFinancialOpen)}
									aria-controls="c-financial"
									aria-expanded={financialOpen}>
									Financial Assistance
								</Button>
							</Col>
							{/* section */}
							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button '

									onClick={() => handleClick(setSectionOpen)}
									aria-controls="c-fiancial"
									aria-expanded={sectionOpen}>
									Selection
								</Button>
							</Col>
							{/* Documents */}
							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button '

									onClick={() => handleClick(setDocumentsOpen)}
									aria-controls="c-document"
									aria-expanded={documentsOpen}>
									Documents
								</Button>
							</Col>

							{/* Fees */}
							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button '

									onClick={() => handleClick(setFeesOpen)}
									aria-controls="c-feesopen"
									aria-expanded={feesOpen}>
									Fees
								</Button>
							</Col>

							{/* Apply Online */}
							<Col xs={6} sm={4} md={2} lg={2} className="mb-3">
								<Button className='btn-sm c-button '
									onClick={() => handleClick(setApplyonlineOpen)}
									aria-controls="c-applyonline"
									aria-expanded={feesOpen}>
									Apply Online
								</Button>
							</Col>



						</Row>


						{/*dates */}
						<div>
							{datesOpen && <Fade in={datesOpen}>
								<div>

									{/* <p className="fw-bold"> <span className="glowing-text">Orientation Program for Ph.D. Scholars on July 25-26, 2024 - {" "}
							<Link to={"https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_MS_PhD_Jul_24.pdf"} target="_blank;" className="c-link"> Click here </Link></span> </p> */}

									{/* <span> 
									<img src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="30" height="20" />
									<Link className='text-maroon' href="https://files.iittp.ac.in/pdfs/admissions/2024/MS_PhD_July_2024_Flyer.pdf" target="_blank;" className='c-link'><b>Ph.D. Admissions for July-2024 Brochure - Click here</b></Link>
								 </span> */}

									<p className="fw-bold caboutus">	
										<span className="glowing-text">
											Shortlisted Candidates List for the Ph.D. January 2027 cycle - 
											<Link className="c-link" to="https://iittp.ac.in/msphd-admissions" >Click here</Link>
										</span>
									</p>
									<p className="fw-bold caboutus">
										<span className="glowing-text">
											Syllabus for Written test and Interview of Ph.D. January 2027 cycle - 
											<Link className="c-link" to="https://iittp.ac.in/msphd-admissions" >Click here</Link>
										</span>
									</p>	
									

									<Table bordered responsive className='mt-3'>
										<thead>
											<tr>
												<th colSpan="2" className="text-center">
													<h4 className="text-primary">Important Dates</h4>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>Opening date and time for online application</td>
												<td>21 September 2026 (Monday) at 11:00 AM</td>
											</tr>
											<tr>
												<td>Closing date and time for online application</td>
												<td>12 October 2026 (Monday) upto 05:00 PM</td>
											</tr>

											<tr>
												<td>Written Test / Interview</td>
												{/* <td><b className="c-link glowing-text">Will be updated soon..</b></td> */}
												<td><b className="c-link glowing-text"> To be Announced</b></td>
											</tr>
											<tr>
												<td>Announcement of Results</td>
												{/* <td><b className="c-link glowing-text">Will be updated soon..</b></td> */}
												<td><b className="c-link glowing-text">To be Announced</b></td>
											</tr>
											<tr>
												<td>Reporting to Campus</td>
												<td><b className="c-link glowing-text">To be Announced</b></td>
												{/* <td><b>From 29th November 2025 (Saturday)</b></td> */}
											</tr>
											<tr>
												<td>Date of Orientation Program</td>
												{/* <td><b className="c-link glowing-text">	Will be updated soon </b></td> */}
												<td><b className="c-link glowing-text">To be Announced </b></td>
												{/* <td><b>	Monday, 1st December 2025</b></td> */}
											</tr>

											{/* <tr>
											<td>Commencement of classes</td>
											<td><b>Thursday, August 1, 2024</b></td>
										</tr> */}

										</tbody>
									</Table>

									<b>Please write to <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link>  or call 0877 250 3532 for  any questions or queries regarding admission related matters. </b>
								</div>
							</Fade>
							}
						</div>


						{/*Guidelines*/}

						<div>
							{guidelinesOpen && <Fade in={guidelinesOpen}>
								<div className='c-lineheight2dot5'>

									<h4 className="mb-3">Important Guidelines for Ph.D. Application</h4>
									<ol className="list-group list-group-numbered caboutus"

										style={{ textAlign: 'justify', fontSize: '12pt' }}>
										<li>
											The link to the online application form is available in the Apply Online tab. After filling out the form, please take a print and keep it for your record.
										</li>
										<li>
											The application fee is as follows:
											<ul className='myulcustarrow caboutus'>
												<li>
													GEN/EWS/OBC-NCL Male candidates: Rs.400/-
												</li>
												<li>
													GEN/EWS/OBC-NCL Female candidates: Rs.200/-
												</li>
												<li>
													SC/ST and PwD candidates: Rs.200/-
												</li>
											</ul>
											<p style={{ color: '#2009df' }}>The application fee is non-refundable. Please ensure to save the payment reference number.</p>
										</li>
										<li>
											A candidate can apply to more than one division among all departments; however, the maximum number of divisions to which he/she can apply will be three.
										</li>
										<li>
											Candidates called for the written test/interview must produce a copy of the application submitted online along with originals and photocopies of the relevant certificates.
										</li>
										<li>
											Reservation/concession/relaxations for EWS/OBC-NCL/SC/ST/PwD and Kashmiri- Migrants (KM), including Kashmiri Pandits/Kashmiri Hindu Families: As per the Government of India rules. A copy of a valid OBC-NCL/ST/SC/EWS/PwD certificate must be uploaded during the ONLINE application and must be submitted at the time of admission.
										</li>
										<li>
											A Statement of Purpose (SoP) must be uploaded along with the online application. The guidelines for preparing the SoP are available at this <Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/1.docx" target="_blank" rel="noopener noreferrer">Link</Link>.
										</li>
										<li>
											At the time of physical reporting to the Institute, candidates must submit self-attested copies of the relevant certificates as specified in the Documents tab, failing which admission will stand cancelled.
										</li>
										<li>
											Please make all files ready with following format and size before going to file upload:
											<ul className='myulcustarrow caboutus'>
												<li> Passport size Photo (jpg, jpeg, png), size &lt;=500 KB</li>
												<li> Signature (format jpg, jpeg, png) size &lt;= 200 KB</li>
												<li> 10th Certificate (pdf) size &lt;=1024 KB</li>
												<li> 12th / Diploma / Equivalent Certificate (pdf) size &lt;=1024 KB</li>
												<li> Qualifying UG Degree Certificate (pdf) size &lt;=1024 KB</li>
												<li> Consolidated UG mark sheet (pdf) size &lt;=1024 KB</li>
												<li> Qualifying PG Degree Certificate (pdf) size &lt;=1024 KB</li>
												<li> Consolidated PG mark sheet (pdf) size &lt;=1024 KB</li>
												<li> Community Certificate if applicable (pdf) size &lt;= 1024 KB</li>
												<li> PwD Certificate if applicable (pdf) size &lt;= 1024 KB</li>
												<li> Applicable National Level Exams/GATE (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
												<li> SoP/Research Proposal, (pdf) size &lt;=1024 KB</li>
												<li> First page of publication, if applicable (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
											</ul>
											<p><b>Additional documents for external/part-time/internal category candidates</b></p>
											<ul className='myulcustarrow caboutus'>
												<li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
												<li> No-Objection Certificate or Undertaking as given, format available as follow below:
													<ul className='myulcustarrow caboutus'>
														<li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
														<li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
													</ul>
												</li>
											</ul>
										</li>
										<p>Note: Candidate must produce NoC at the time of Written Test / Interview</p>
										<li>
											Please visit the institute’s website regularly for important announcements and results.
										</li>
										<li>
											In case of any queries, please write to{' '}
											<Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link> or call 0877 250 3532 (9.00 AM to 5.30 PM on all working days).
										</li>
									</ol>

								</div>
							</Fade>
							}
						</div>


						{/*Categoies*/}

						<div>
							{categoryOpen && <Fade in={categoryOpen}>
								<div className='c-lineheight2dot5'>

									<h4 className="mb-3">Ph.D. admissions are made under various modes as mentioned below:</h4>

									<ul className="caboutus">
										<li>
											<b>1. Regular-HTRA/Project:</b> Scholars funded by Half-Time Research Assistantship (HTRA) or a Project administered by CSRC, IITT.
										</li>
									</ul>

									<ul className="caboutus">
										<li class="caboutus">
											<b> 2.	Regular-Fellowship:</b> Scholars funded by outside agencies such as UGC, CSIR, PMRF, etc.</li>
										<li class="caboutus"><b>3.	Part-Time:</b>
											<ul className='myulcustarrow caboutus'>


												<li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
												<li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>
												<li> The following documents are required along with the application
													<ul className='myulcustarrow'>
														<li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
														<li> No-Objection Certificate or Undertaking
															<ul className='myulcustarrow'>
																<li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
																<li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
															</ul>
														</li>
													</ul>

												</li>

												<li> The following documents are required at the time of admission
													<ul className='myulcustarrow caboutus'>
														{/* <li>Certificate of Support from the Employer</li> */}
														<li>Relieving (Leave)  Certificate from the Employer: <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank;" className='c-link'>Link</Link></li>
													</ul>
												</li>

											</ul>
										</li>
									</ul>
									<p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>

									<ul className='caboutus'>
										<li>
											<b>  4. External: </b>

											<ul className='myulcustarrow caboutus'>
												<li> The applicant must be sponsored by and employed in an industry/organization/national laboratory having R&D facilities and recognized by DST or DSIR or IITT.</li>
												<li> The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
												<li> Research scholars admitted under this category will normally carry out part or all their research in the parent organization under supervision of a faculty from IIT Tirupati and a co-supervisor employed in their parent organization.</li>

												<li> The following documents are required at the time of application
													<ul className='myulcustarrow'>
														<li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
														<li> No-Objection Certificate or Undertaking
															<ul className='myulcustarrow'>
																<li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
																<li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
															</ul>
														</li>
													</ul>
												</li>
												<li> The following documents are required at the time of admission
													<ul className='myulcustarrow caboutus'>
														<li>Certificate of Support from the Employer</li>
														<li>Relieving (Leave) Certificate from the Employer: <a href="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank;" className='c-link'>Link</a></li>
													</ul>
												</li>
											</ul>

										</li>
									</ul>
									<p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>

									<ul>
										<li>
											<b>  5. Internal (IIT Tirupati Staff): </b>

											<ul className='myulcustarrow caboutus'>
												<li> Permanent employees of IITT with at least two years of work experience</li>
												<li> The applicant should have at least two years of experience as a regular employee as on the last date of receipt of applications.</li>
												<li><b>Candidate must produce NoC at the time of Written Test / Interview</b></li>
											</ul>
										</li>
									</ul>


									<ul>
										<li>
											<b> Note: </b>

											<ul className='myulcustarrow caboutus'>
												<li> The minimum residential requirement for the Ph.D. research scholars under External/Part-time category of admission is one semester.</li>
												<li> Candidates admitted under Non-HTRA category cannot be moved to HTRA category at a later date.</li>
												<li> More details on External/Part-time category of admission, including any questions regarding the recognition of the organization/laboratory might be addressed to the Head of the department of interest or <Link className='c-link' to="mailto:admissions@iittp.ac.in">admissions@iittp.ac.in</Link> </li>
											</ul>
										</li>
									</ul>


								</div>
							</Fade>
							}
						</div>


						{/*Areas*/}

						<div>
							{areasOpen && <Fade in={areasOpen}>
								<div>
									<h4 className='mb-4'>Research Areas</h4>
									{/*<p class="caboutus">
										Applicants are required to select the research areas in the online admission portal as per the availability in the respective category/scheme. The available research areas for July 2026 admission cycle are tabulated below.</p>
									<p class="caboutus"> <b>SoP is mandatory for Chemical Engineering, Chemistry, Computer Science and Engineering, Electrical Engineering, Physics, Mathematics and Statistics and Mechanical Engineening. <a className='c-link' href="https://files.iittp.ac.in/pdfs/msphd/admissions/SoP.pdf" target="_blank">Click here for SoP template</a></b>
									</p>

									<p class="caboutus"> <b>Note:</b> The research areas marked with asterisk(*) are available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.
									</p>*/}

									

									{/* <p className='fw-bold text-info'><em>*These research areas available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.</em></p> */}

<p>
    Applicants are required to select the research areas in the online admission portal as per the availability in the respective category/scheme. The available research areas for January 2027 admission cycle are tabulated below.
</p>

<p>
    SoP is mandatory for all departments.{' '}
    <a
        href="https://files.iittp.ac.in/pdfs/msphd/admissions/SoP.pdf"
        target="_blank"
        rel="noreferrer"
    >
        Click here for SoP template
    </a>
</p>

<p>
    <b>Note:</b> The research areas marked with asterisk(*) are available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.
</p>

<Table bordered responsive className='mt-3 c-table'>
    <colgroup>
        <col style={{ width: '18%' }} />
        <col style={{ width: '20%' }} />
        <col style={{ width: '37%' }} />
        <col style={{ width: '25%' }} />
    </colgroup>

    <tbody>

        {/* Header */}
        <tr>
            <td><b>Department</b></td>
            <td><b>Division</b></td>
            <td><b>Areas of Research</b></td>
            <td><b>Additional Information</b></td>
        </tr>



        {/* 1. Chemical Engineering */}
        <tr>
            <td rowSpan='27'>Chemical Engineering</td>
            <td rowSpan='27'>Chemical Engineering</td>
            <td>Hydrogen Fuel Cell Characterization</td>
            <td></td>
        </tr>
        <tr>
            <td>Critical minerals Recovery - Molecular Dynamics study</td>
            <td></td>
        </tr>
        <tr>
            <td>Electrocatalysis for green hydrogen and fuels</td>
            <td></td>
        </tr>
        <tr>
            <td>Sodium ion battery materials</td>
            <td></td>
        </tr>
        <tr>
            <td>Recycling of spent Li-ion batteries</td>
            <td></td>
        </tr>
        <tr>
            <td>Catalytic conversion of CO2</td>
            <td></td>
        </tr>
        <tr>
            <td>Solar cells</td>
            <td></td>
        </tr>
        <tr>
            <td>Wearbale biosensors/bimedical devices</td>
            <td></td>
        </tr>
        <tr>
            <td>Solid state battery and interface</td>
            <td></td>
        </tr>
        <tr>
            <td>Computer vision for healthcare diagnostics</td>
            <td></td>
        </tr>
        <tr>
            <td>Microfluidics</td>
            <td></td>
        </tr>
        <tr>
            <td>Biomass to chemicals</td>
            <td></td>
        </tr>
        <tr>
            <td>Bioactive Extraction for Food</td>
            <td></td>
        </tr>
        <tr>
            <td>Critical minerals Recovery - Experimental study</td>
            <td></td>
        </tr>
        <tr>
            <td>Computationally engineered materials</td>
            <td></td>
        </tr>
        <tr>
            <td>Molecular simulations</td>
            <td></td>
        </tr>
        <tr>
            <td>Materials for gas capture</td>
            <td></td>
        </tr>
        <tr>
            <td>Green hydrogen supply chain optimization</td>
            <td></td>
        </tr>
        <tr>
            <td>Intelligent Control</td>
            <td></td>
        </tr>
        <tr>
            <td>Sustianable energy systems modeling</td>
            <td></td>
        </tr>
        <tr>
            <td>Reinforcement learning for vehicle routing</td>
            <td></td>
        </tr>
        <tr>
            <td>ML/AI for climate modeling and weather forecasting</td>
            <td></td>
        </tr>
        <tr>
            <td>Complex networks for process analysis and process monitoring</td>
            <td></td>
        </tr>
        <tr>
            <td>Non-linear identification and state estimation</td>
            <td></td>
        </tr>
        <tr>
            <td>Circular economy</td>
            <td></td>
        </tr>
        <tr>
            <td>ML for CO2 capture</td>
            <td></td>
        </tr>
        <tr>
            <td>AI/ML for adsorbent materials</td>
            <td></td>
        </tr>

		{/* 2. Chemistry */}
        <tr>
            <td rowSpan='14'>Chemistry</td>
            <td rowSpan='14'>Chemistry</td>
            <td>
                Organocatalyzed Regioselective functionalization of carbohydrates and
                synthesis of glycoclipids*
            </td>
            <td></td>
        </tr>
        <tr>
            <td>Asymmetric Total Synthesis of Bioactive Natural Products and Drug intermediates*</td>
            <td></td>
        </tr>
        <tr>
            <td>Functional organic optoelectronic materials featuring main group elements</td>
            <td></td>
        </tr>
        <tr>
            <td>Computational Chemistry and Soft-Matter: Small Molecules, Materials, Zinc ion Battery, Proteins, and Machine Learning*</td>
            <td>Organic semiconductors featuring main group elements</td>
        </tr>
        <tr>
            <td>COFs and MOFs Materials for Energy Storage, Organic Battery and Sulfur Battery</td>
            <td>Students from Organic or Physical Chemistry Background and/or Interested in Interdisciplinary Research .</td>
        </tr>
        <tr>
            <td>Computational Chemistry: Modelling Luminophores, Photosensitizers, Photovoltaic Materials and Proton Conduction in Porous Materials</td>
            <td>Students from any background of chemical science can apply, however, a strong interest in physical chemistry, chemical physics, statistical mechanics, and programming would be beneficial. </td>
        </tr>
        <tr>
            <td>Organic Synthesis: Photo- and Electro-Catalysis for Bio-Active Compounds Synthesis; Sustainable Method Developments for API and Drug Molecules*</td>
            <td>Candidates should have strong interest in physical and materails chemistry</td>
        </tr>
        <tr>
            <td>Theoretical and Computational Chemistry: Stochastic Thermodynamics, Information Engines, Quantum Thermodynamics, Fluctuation induced Biophysical processes, AI-ML in Brownian Motion</td>
            <td></td>
        </tr>
        <tr>
            <td>Nanomaterials &amp; Quantum dots for sensing, Coordination Chemistry, Medicinal Chemistry &amp; Drug Discovery, Environmental Chemistry, and Chemical Biology*</td>
            <td>should have interest in physical chemistry and should have mathematics in undergraduate level</td>
        </tr>
        <tr>
            <td>Supramolecular chemistry of interlocked molecules, Transition metal-oxide cluster chemistry for Energy Storage, Electrochemistry and Redox Flow Battery Systems*</td>
            <td></td>
        </tr>
        <tr>
            <td>Experimental physical chemistry and chemical biology including fluorescence spectroscopy and microscopy for the sensing and treatment of cancer</td>
            <td></td>
        </tr>
        <tr>
            <td>Coordination and bioinorganic chemistry, redox-driven small molecule activation, bioinspired catalysis.</td>
            <td>should have interest in experimental physical chemistry and exploring the solution for human health-related problem</td>
        </tr>
        <tr>
            <td>Main Group Organometallic Chemistry and Metallomimetic Catalysis</td>
            <td></td>
        </tr>
        <tr>
            <td>Asymmetric catalysis, aminyl radical chemistry, and moelcular editing*</td>
            <td></td>
        </tr>

        {/* 3. Civil & Environmental Engineering */}
        <tr>
            <td rowSpan='13'>Civil &amp; Environmental Engineering</td>
            <td rowSpan='5'>Environmental Engineering</td>
            <td>Air Quality Modelling and Management</td>
            <td></td>
        </tr>
        <tr>
            <td>Life Cycle and Sustainability Assessment</td>
            <td></td>
        </tr>
        <tr>
            <td>Advanced Water and Wastewater Treatment</td>
            <td>Environmental Engineering</td>
        </tr>
        <tr>
            <td>Applications of Non-Thermal Plasma in Agriculture and Food Crop Management</td>
            <td>Environmental Engineering</td>
        </tr>
        <tr>
            <td>Capacitive Deionization for Water Desalination</td>
            <td>Environmental Engineering</td>
        </tr>

        <tr>
            <td rowSpan='2'>Geotechnical Engineering</td>
            <td>All areas of Geotechnical Engineering</td>
            <td>Geotechnical Engineering</td>
        </tr>
        <tr>
            <td>Rock Engineering</td>
            <td>Geotechnical or Rock Mechanics</td>
        </tr>

        <tr>
            <td rowSpan='2'>Structural Engineering</td>
            <td>All areas of Structural Engineering</td>
            <td></td>
        </tr>
        <tr>
            <td>Construction Materials</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='2'>Transportation Engineering</td>
            <td>Pavement Technology</td>
            <td></td>
        </tr>
        <tr>
            <td>Freight Demand Modelling</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='2'>Water Resources Engineering</td>
            <td>Flood modeling, Digital Twin</td>
            <td>GIS, Remote Sensing</td>
        </tr>
        <tr>
            <td>Water Resources Management</td>
            <td>GIS, Remote Sensing</td>
        </tr>


        {/* 4. Computer Science and Engineering */}
        <tr>
            <td rowSpan='10'>Computer Science and Engineering</td>
            <td rowSpan='3'>Computer Systems</td>
            <td>AI Accelerator and Semiconductor Test</td>
            <td></td>
        </tr>
        <tr>
            <td>Computer Vision</td>
            <td></td>
        </tr>
        <tr>
            <td>Quantum System Architecture</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='4'>Intelligent Systems</td>
            <td>Software Engineering and AI</td>
            <td></td>
        </tr>
        <tr>
            <td>Malware Analysis and AI for Cybersecurity</td>
            <td></td>
        </tr>
        <tr>
            <td>Deep Learning for Medical Imaging</td>
            <td></td>
        </tr>
        <tr>
            <td>ML for IOT</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='3'>Algorithms and Theory</td>
            <td>Algorithms and complexity , Quantum Computing</td>
            <td></td>
        </tr>
        <tr>
            <td>Secure Data Analytics</td>
            <td></td>
        </tr>
        <tr>
            <td>Algorithms, Data Structures and Parallel Computing</td>
            <td></td>
        </tr>


        {/* 5. Electrical Engineering */}
        <tr>
            <td rowSpan='13'>Electrical Engineering</td>
            <td rowSpan='3'>Power and Control</td>
            <td>Power Electronics</td>
            <td></td>
        </tr>
        <tr>
            <td>Control, Optimization, and Robotics</td>
            <td></td>
        </tr>
        <tr>
            <td>Power Systems and Smart Grids</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='1'>Semiconductor Devices</td>
            <td>Semiconductor Devices</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='3'>VLSI</td>
            <td>Harsh Environment Electronics and Sensors</td>
            <td></td>
        </tr>
        <tr>
            <td>Digital VLSI Design</td>
            <td></td>
        </tr>
        <tr>
            <td>Analog VLSI Design</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='4'>RF and Microwaves</td>
            <td>Advanced Antenna Systems and Base Station</td>
            <td>For the PhD program, eligible applicants include those with a UG/PG degree in EE, EC, IN, and PH, or any related field.</td>
        </tr>
        <tr>
            <td>RF and Microwave Components</td>
            <td>For the PhD program, eligible applicants include those with a UG/PG degree in EE, EC, IN, and PH, or any related field.</td>
        </tr>
        <tr>
            <td>RF Integrated Circuits</td>
            <td>For the PhD program, eligible applicants include those with a UG/PG degree in EE, EC, IN, and PH, or any related field.</td>
        </tr>
        <tr>
            <td>Metamaterials and RF Sensing</td>
            <td>For the PhD program, eligible applicants include those with a UG/PG degree in EE, EC, IN, and PH, or any related field.</td>
        </tr>

        <tr>
            <td rowSpan='2'>Next-Generation Wireless Communications and Networks</td>
            <td>Communication Networks</td>
            <td>For the PhD program, candidates with a UG/PG degree in EE, EC and Physics are encouraged to apply.</td>
        </tr>
        <tr>
            <td>Quantum Information Theory</td>
            <td>For the PhD program, candidates with a UG/PG degree in EE, EC and Physics are encouraged to apply.</td>
        </tr>



        {/* 6. Humanities and Social Sciences */}
        <tr>
            <td rowSpan='9'>Humanities and Social Sciences</td>
            <td rowSpan='1'>Urban and Regional Planning</td>
            <td>Urban Mobility</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='5'>Operations Management</td>
            <td>Supply Chain Management*</td>
            <td>Part-time applications are also invited</td>
        </tr>
        <tr>
            <td>Industrial Engineering*</td>
            <td>Part-time applications are also invited</td>
			
        </tr>
        <tr>
            <td>Production Planning and Control*</td>
            <td>Part-time applications are also invited</td>
        </tr>
        <tr>
            <td>Project Management*</td>
            <td>Part-time applications are also invited</td>
        </tr>
        <tr>
            <td>Applications of Operations Research, Statistics and Machine Learning in Operations Management*</td>
            <td>Part-time applications are also invited</td>
        </tr>

        <tr>
            <td rowSpan='3'>Economics</td>
            <td>Development Economics</td>
            <td>Part-time applications are also invited. UGC-JRF applications are also invited</td>
        </tr>
        <tr>
            <td>Network Economics</td>
            <td>Part-time applications are also invited. UGC-JRF applications are also invited</td>
        </tr>
        <tr>
            <td>Financial Economics</td>
            <td>Part-time applications are also invited. UGC-JRF applications are also invited</td>
        </tr>
		
        {/* 7. Mathematics and Statistics */}
        <tr>
            <td rowSpan='17'>Mathematics and Statistics</td>
            <td rowSpan='4'>Mathematics</td>
            <td>Partial Differential Equations</td>
            <td></td>
        </tr>
        <tr>
            <td>Inverse Problems</td>
            <td></td>
        </tr>
        <tr>
            <td>Number Theory</td>
            <td></td>
        </tr>
        <tr>
            <td>Numerical Partial Differential Equations</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='13'>Statistics</td>
            <td>Statistical Finance</td>
            <td></td>
        </tr>
        <tr>
            <td>Statistical Signal Processing</td>
            <td></td>
        </tr>
        <tr>
            <td>Spatial and Spatio-Temporal Models</td>
            <td></td>
        </tr>
        <tr>
            <td>Design of Experiments</td>
            <td></td>
        </tr>
        <tr>
            <td>Statistical Inferecne</td>
            <td></td>
        </tr>
        <tr>
            <td>Reliability and Survival Analysis</td>
            <td></td>
        </tr>
        <tr>
            <td>Time Series Analysis</td>
            <td></td>
        </tr>
        <tr>
            <td>Extreme Value Theory and Rare Event Modeling</td>
            <td></td>
        </tr>
        <tr>
            <td>Biostatistics*</td>
            <td></td>
        </tr>
        <tr>
            <td>Inlier-Prone Models*</td>
            <td></td>
        </tr>
        <tr>
            <td>Multivariate Distributions and Dependence Modeling (Copulas)</td>
            <td></td>
        </tr>
        <tr>
            <td>Bayesian Inference and Computation</td>
            <td></td>
        </tr>
        <tr>
            <td>Statistical Analysis of Network</td>
            <td></td>
        </tr>


        {/* 8. Mechanical Engineering */}
        <tr>
            <td rowSpan='16'>Mechanical Engineering</td>
            <td rowSpan='6'>Advanced Manufacturing</td>
            <td>Piezoelectric thin films</td>
            <td></td>
        </tr>
        <tr>
            <td>Multiferroic materials</td>
            <td></td>
        </tr>
        <tr>
            <td>Self-Healing Composite Materials and Non Destructive Testing (NDT)</td>
            <td></td>
        </tr>
        <tr>
            <td>Semiconductors and High-performance computing thermal Management Architectures</td>
            <td></td>
        </tr>
        <tr>
            <td>Smart manufacturing platform for the Hybrid Metal Additive Manufacturing process</td>
            <td></td>
        </tr>
        <tr>
            <td>Shape-Agnostic Machine Learning-Based Prediction and Optimization of Thermal Evolution, Cooling Rates, and Distortion in Metal Additive Manufacturing</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='7'>Fluids &amp; Thermal Engineering</td>
            <td>Hydrogen storage, Hydrogen combustion</td>
            <td></td>
        </tr>
        <tr>
            <td>Multiphase flows, CFD</td>
            <td></td>
        </tr>
        <tr>
            <td>Liquid Atomization and Sprays</td>
            <td></td>
        </tr>
        <tr>
            <td>Drones, wind turbine aerodynamics, CFD, low speed flows, wind tunnel experiments</td>
            <td></td>
        </tr>
        <tr>
            <td>Fluid-structure interaction</td>
            <td></td>
        </tr>
        <tr>
            <td>Hydrogen storage, Thermal energy storage, Absorption cooling</td>
            <td></td>
        </tr>
        <tr>
            <td>Water Waves: Experiments, Mathematical Modeling, and CFD</td>
            <td></td>
        </tr>

        <tr>
            <td rowSpan='3'>Solid Mechanics &amp; Design</td>
            <td>Automotive dynamics, vibrations, vibro-acoustics</td>
            <td></td>
        </tr>
        <tr>
            <td>Computational solid mechanics, continuum mechanics, plasticity, phase transformations, machine learning in mechanics</td>
            <td>Solid Mechanics and Design</td>
        </tr>
        <tr>
            <td>Biomechanics, Medical Devices, Solid Mechanics, Finite Element Analysis</td>
            <td>Solid Mechanics and Design</td>
        </tr>


        {/* 9.Physics */}
        <tr>
            <td rowSpan='10'>Physics</td>
            <td rowSpan='10'>Physics</td>
            <td>Computational Condensed Matter Physics</td>
            <td>Prior knowledge to Density Fucntioanl Theory (DFT) is preferable; NLE required</td>
        </tr>
        <tr>
            <td>Theoretical quantum matter</td>
            <td></td>
        </tr>
        <tr>
            <td>2D Quantum Materials and Devices (Experimental)</td>
            <td>Candidates having background of Physics, Materials Science and Engineering are eligible</td>
        </tr>
        <tr>
            <td>2D Semiconducotrs and Heterostructure Devices (Experimental)</td>
            <td>Candidates having background of Physics, Materials Science and Engineering are eligible</td>
        </tr>
        <tr>
            <td>Quantum materials (experimental and computational)</td>
            <td></td>
        </tr>
        <tr>
            <td>Theoretical Atomic, molecular and optical physics</td>
            <td></td>
        </tr>
        <tr>
            <td>Theoritical &amp; Experimental Plasma Physics*</td>
            <td></td>
        </tr>
        <tr>
            <td>Quantum Computational Algorithms for Partial Diifferntial Equation Solver</td>
            <td></td>
        </tr>
        <tr>
            <td>Experimental Quantum Sensing (Portable atomic clocks)</td>
            <td>Candidates having background of Physics and Electrical Engineering are eligible</td>
        </tr>
        <tr>
            <td>Astronomy and Astrophysics</td>
            <td></td>
        </tr>


       

    </tbody>
</Table>
								</div>
							</Fade>
							}
						</div>




						{/*Eligiblity*/}

						<div>
							{eligiblityOpen && <Fade in={eligiblityOpen}>
								<div>
									<h4 className='mb-4'>Eligibility</h4>
									<p className='caboutus'>Candidates seeking admission to the Ph.D. program in different disciplines are required to meet the minimum eligibility criteria regarding their educational qualifications and any additional qualifying exams, as outlined in the following table:</p>
									<Table bordered responsive className='mt-3 c-table' >
										<tbody>
											{/* <tr>
												<td colSpan="4">
												 <b>Minimum Qualifications for Admission to the Regular Ph.D program</b>
													Candidates applying for the Ph.D program in one of the following areas need to have any one of the minimum qualifications mentioned in the table below:
												</td>
						</tr> */}
											<tr>
												{/* <td rowSpan="2">
													<b>
													Discipline
													</b>
												</td> */}
												<td colSpan="3" >
													<b>
														Minimum Qualifications for PhD Admission for Regular Category
													</b>
												</td>
											</tr>
											<tr>
												<td width="65" >
													<b>
														S. No.
													</b>
												</td>
												<td >
													<b>
														Educational Qualifications
													</b>
												</td>
												<td >
													<b>
														Additional Requirements
													</b>
												</td>
											</tr>
											<tr>
												{/* <td rowSpan="5" height="422" valign="middle">
													<b>
														Engineering
													</b>
												</td> */}
												<td >
													<b>
														1
													</b>
												</td>
												<td >

													M.E/M.Tech/MS(R) in Engineering <br /><br /><p style={{ textAlign: 'center' }}>(or)</p>
													5-year integrated Master’s degree in Engineering/ B.Tech + M.Tech Dual Degree<br /><br /><p style={{ textAlign: 'center' }}>(or)</p>
													5-year integrated degree or B.S+M.S from CFTI<br /><br /><p style={{ textAlign: 'center' }}>(or)</p>
													Master’s degree in Sciences/Humanities and Social Sciences/Management from IITs with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)


												</td>
												<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
													None
												</td>
											</tr>
											<tr>
												<td >
													<b>
														2
													</b>
												</td>
												<td >
													Master's degree in the relevant Sciences/Humanities and Social Sciences/Management from any recognized university/institute.
												</td>
												<td >

													National Level Eligibility Test (NLT) such as GATE /UGC-NET/CSIR-NET/NBHM/  INSPIRE/JEST or an equivalent one tenable at the time of admission.


												</td>
											</tr>
											<tr>
												<td >
													<b>
														3<sup>*</sup>
													</b>
												</td>
												<td >
													Master's degree in the relevant Sciences/Humanities and Social Sciences/Management from any recognized university/institute without a National Level Eligibility Test (NLT) for PhD.
												</td>
												<td >
													(i)	Candidates with more than 5 years of relevant experience after the Master's <br /><br /><p style={{ textAlign: 'center' }}>(or)</p>
													(ii) Candidates with a Master’s degree from CFI other than IITs with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD) <br /><br /><p style={{ textAlign: 'center' }}>(or)</p>
													(iii) Candidates qualified in the international-level post-graduate admission examination, such as the GRE.
												</td>
											</tr>
											<tr>
												<td >
													<b>
														4<sup>#</sup>
													</b>
												</td>
												<td >
													4-year Bachelor’s degree from a CFTI with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
												</td>
												<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
													None
												</td>
											</tr>
											<tr>
												<td >
													<b>
														5<sup>#</sup>
													</b>
												</td>
												<td >
													4-year Bachelor's degree from any recognized university/institute with a minimum CGPA of 7.0 on a 10.0 point scale (6.5 for EWS/OBC- NCL and 6.0 for SC/ST/PwD)

												</td>
												<td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
													GATE tenable at the time of admission
												</td>
											</tr>
											{/*  <tr>
												<td rowSpan="5" valign="middle">
													<b>
														Sciences
													</b>
												</td>
												<td >
													<b>
														6
													</b>
												</td>
												<td >

													• M.E/M.Tech or M.S by Research in engineering <br />(or)<br />
													• 2 year M.Sc from IITs (entry through JAM) with a minimum CGPA of 8.0 on 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD) <br />(or)<br />
													• B.S+M.S, or 5-year integrated degree from CFTI

												</td>
												<td >
													None
												</td>
											 </tr>
											<tr>
												<td >
													<b>
														7
													</b>
												</td>
												<td >

													• M.Sc from IITs without minimum CGPA 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)<br />(or)<br />
													• M.Sc from institutions other than IITS

												</td>
												<td >

												Valid GATE score or UGC-NET/CSIR-NET/NBHM/INSPIRE/JEST or equivalent qualification, tenable for the current year in the relevant area.

												</td>
											</tr>
											<tr>
												<td >
													<b>
														8<sup>#</sup>
													</b>
												</td>
												<td >
													B.S/B.E/B.Tech from a Centrally Funded Technical Institute (CFTI) with a minimum CGPA of 8 on 10 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD).
												</td>
												<td >
													None
												</td>
											</tr>
											<tr>
												<td >
													<b>
														9<sup>#</sup>
													</b>
												</td>
												<td >
													B.S/B.E/B.Tech from a CFTI without minimum CGPA 8 on a 10 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD).
												</td>
												<td >
													Valid GATE score
												</td>
											</tr>
											<tr>
												<td >
													<b>
														10<sup>#</sup>
													</b>
												</td>
												<td >
													B.E/BTech from any other university, with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
												</td>
												<td >
													Valid GATE score
												</td>
											</tr>
											<tr>
												<td rowSpan="1" valign="middle">
													<b>
														Humanities and Social Sciences
													</b>
												</td>
												<td >
													<b>
														11
													</b>
												</td>
												<td >
													Master’s degree/dual-degree or equivalent in a relevant discipline
												</td>
												<td >

												Qualifying UGC-NET/CSIR-NET/ GATE score or equivalent qualification, tenable for the current year in the relevant area or an international-level post graduate admission examination such as GRE.<br /><br />Candidates with only a GRE (or equivalent international-level post graduate admission examination) score are not eligible for HTRA.

												</td>
											</tr> */}
											{/* <tr>
												<td colSpan="4" >
													# Candidates with Educational Qualifications as mentioned in the S.No. 3,4,5,8,9,10 will be considered for Direct Ph.D.

												</td>
											</tr>
											<tr>
												<td colSpan="4" >
													Note: A valid GATE score or UGC/CSIR-NET/INSPIRE/NBHM qualification etc. is not required in the case of candidates applying under the external/part-time/internal staff category. 
													
												</td>
											</tr> */}
											<tr>
												<td colSpan="3" >
													* The candidates can only be admitted under the Regular-Project category without eligibility for conversion to the Regular- HTRA.

												</td>
											</tr>
											<tr>
												<td colSpan="3" >
													# Candidates with Educational Qualifications as mentioned in S. No. 4 and 5 will be considered for Direct MS(R)+PhD.

												</td>
											</tr>
										</tbody>


									</Table>


									<h5 className='mt-3 mb-3'>Minimum Qualifications for candidates in Part-Time/External/Internal Category:</h5>

									<p class="caboutus">The educational qualifications remain the same as those prescribed for the regular admission category. However, a valid GATE score or UGC-NET/CSIR-NET/INSPIRE/NBHM/JEST or an equivalent qualification as applicable for the regular admission category is not required
										In addition, applicants under External/Part-Time/Internal category have to satisfy the following criteria:
									</p>
									<h5 className='mt-3 mb-3'> External:</h5>

									<ul className='myulcustarrow caboutus'>
										<li>The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
										<li> The applicant must be sponsored by and employed in an industry/organization/national laboratories, having R&D facilities and recognized by DST/DSIR or having an MoU with IIT Tirupati.</li>
									</ul>

									<h5 className='mt-3 mb-3'>Part-Time:</h5>

									<ul className='myulcustarrow caboutus'>
										<li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
										<li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>
									</ul>

									<h5 className='mt-3 mb-3'>Internal (IIT Tirupati Staff):</h5>
									<ul className='myulcustarrow caboutus'>
										<li> The applicant must be a regular employee of IIT Tirupati.</li>
										<li> The applicant should have atleast two years of experience as a regular employee as on the last date of receipt of applications.</li>
									</ul>
									<p class="caboutus">All the applicants are requested to go through the Ordinances of Ph.D. programme thoroughly before applying.</p>
								</div>
							</Fade>
							}
						</div>

						{/*Fiancial  Assistance*/}

						<div>
							{financialOpen && <Fade in={financialOpen}>
								<div>
									<h4 className='mb-4'>Financial Assistance</h4>
									<p className='caboutus'>
										Financial assistance will be provided as per Ministry of Education (MoE) norms. All full time regular scholars admitted to Ph.D. and M.S (Research) programs are eligible for the Half-time Research Assistantship (HTRA) for which:
									</p>
									<ul className='myulcustarrow caboutus'>
										<li>
											They should work for 8 hours per week for the Institute to earn this assistantship. The work would normally involve assistance in teaching/research and will be assigned by the Institute.
										</li>
										<li>
											Renewal of assistantship every semester will be contingent on enrolment, satisfactory progress in research work and good performance during the preceding semester in the discharge of responsibility as teaching/ research assistant.
										</li>
										<li>
											Assistantship for candidates who have qualified through UGC-JRF, CSIR-JRF, ICMR & AICTE etc. will be as per the norms of the funding agency.
										</li>
									</ul>
								</div>
							</Fade>
							}
						</div>


						{/*Section*/}

						<div>
							{sectionOpen && <Fade in={sectionOpen}>
								<div>
									<h4 className='mb-4'>Selection Procedure</h4>
									<p className=''>The selection committee will call eligible candidates based on the minimum eligibility requirements and additional screening criteria for a written test (if any) and interview.</p>
								</div>
							</Fade>}
						</div>


						{/*Documents*/}

						<div>
							{documentsOpen && <Fade in={documentsOpen}>
								<div>
									<h4 className='mb-4'>Original Documents to be submitted for Verification:</h4>
									<p>
										<b>At the time of Interview and/or Written Test:</b>
									</p>
									<p>Self-attested copies of the following documents must be submitted at the time of interview and/or written test.</p>
									<ul className='myulcustarrow caboutus'>
										<li>
											Copy of application
										</li>
										<li>
											Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
										</li>
										<li>
											Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
										</li>
										<li>
											Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.
										</li>
										<li>
											Copy of GATE score or CSIR-UGC-JRF/LS/NET/DAE-JEST or any other fellowship award.
										</li>
										<li>
											Candidates applying under External Category must produce
											<Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx">No Objection Certificate - Click Here</Link>
										</li>

										<li>
											Candidates applying under Part-Time Category must produce
											<Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx">No Objection Certificate - Click Here</Link>
										</li>

										<li>
											Candidates applying under Internal Category must produce : No Objection Certificate
										</li>


									</ul>
									<p className='text-primary caboutus'>
										Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
									</p>
									<p>
										<b>At the time of Admission:</b>
									</p>
									<p className='caboutus'>Self-attested copies of the following documents must be submitted at the time of admission / registration</p>
									<ul className='myulcustarrow caboutus'>
										<li>
											Offer of admission.
										</li>
										<li>
											Birth Certificate / SSC / SSLC certifcate as proof of Name and Date of birth
										</li>
										<li>
											Any valid government ID proof such as Aadhaar, PAN, Passport, Driving License, etc.
										</li>
										<li>
											Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
										</li>
										<li>
											Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
										</li>
										<li>
											Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
										</li>
										<li>
											Candidates admitted under External category must also produce:
											<ol className='ms-3 caboutus'>
												<li>
													No Objection Certificate for using Research Facilities on the employer’s premises. <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" className='c-link'>(Link)</Link>
												</li>
												<li>
													Consent of Co-supervisor from the parent organization in case of external candidates. <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Co-Supervisor_Particulars.docx" target="_blank" className='c-link'>(Link)</Link>
												</li>
												<li>
													Relieving order from the employer <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank" className='c-link'>(Link)</Link>
												</li>

											</ol>
										</li>

										Candidates admitted under Part-Time category must also produce:
										<ol className='ms-3'>
											<li>
												Relieving order from the employer <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank" className='c-link'>(Link)</Link>
											</li>
										</ol>
									</ul>
									<p className='text-primary caboutus'>
										Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.
									</p>
								</div>
							</Fade>}
						</div>

						{/*Section*/}

						<div>
							{feesOpen && <Fade in={feesOpen}>
								<div>
									<h4 className='mb-4'>Fees and Deposits</h4>
									<p className='caboutus'>The applicable tuition and other fee/ deposits for Ph.D. scholars is available at the following <Link to="/fee-structure" className='c-link'>link</Link>.</p>
								</div>
							</Fade>}
						</div>
						{/*Apply Online*/}

						<div>
							{applyonlineOpen && <Fade in={applyonlineOpen}>
								<div>
									<h4 className='mb-4'>Apply Online</h4>
									{/* <p><b>To Apply Online</b> : <Link to="#" className='c-link'><b>Will be updated soon..</b></Link> </p> */}
									<p><b>To Apply Online</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/phdapplication" className='c-link'><b>Click Here</b></Link> </p>
									{/* <p><b>To login and download application</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/phdapplication.php" target="_blank" className='c-link'><b>Click Here</b></Link>
									</p> */}

								</div>
							</Fade>}
						</div>


					</Col>

				</Row>
				{/* </> */}
			</Container>
		</section>
	);
}

export default Test_Phd_AdmissionELe;
